// MainComp.jsx

import React, { useEffect } from 'react';
import './MainComp.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const MainComp = () => {
  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <div className="mainContact-section">
      <div className="overlay"></div>
      <div className='main-title-Contactsection'>
        <h1 className="mainContact-title" data-aos="fade-down">Contact Us</h1>
      </div>
    </div>
  );
};

export default MainComp;
